// eslint-disable-next-line import/prefer-default-export
export const GetterTypesFromMembers = {
  MEMBER_LIST: 'MEMBER_LIST',
  MEMBER_LIST_LOADING_STATE: 'MEMBER_LIST_LOADING_STATE',
  MEMBER_LIST_ERROR_STATE: 'MEMBER_LIST_ERROR_STATE',
};
